import { render, staticRenderFns } from "./edit-header.component.vue?vue&type=template&id=2b675036&scoped=true"
import script from "./edit-header.component.vue?vue&type=script&lang=js"
export * from "./edit-header.component.vue?vue&type=script&lang=js"
import style0 from "./edit-header.component.vue?vue&type=style&index=0&id=2b675036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b675036",
  null
  
)

export default component.exports